<script lang="ts">
  import translationsStore from '../../../stores/translations.svelte'
  import LiveStatusScreen from './LiveStatusScreen.svelte'
</script>

<LiveStatusScreen>
  {translationsStore.state.live_ended}
</LiveStatusScreen>
